export const ServiceEnum = { mylab: 1, callCenter: 2 };
